import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-failure-page',
  templateUrl: './payment-failure-page.component.html',
  styleUrl: './payment-failure-page.component.scss'
})
export class PaymentFailurePageComponent {}
